const BASE_URI = '/api/v1/';

export const CONTRACT_URI = `${BASE_URI}contract`;
export const CUSTOMER_URI = `${BASE_URI}customer`;
export const CUSTOMERUSER_URI = `${BASE_URI}customeruser`;
export const IMAGEHANDLER_URI = `${BASE_URI}imagehandler`;
export const INVENTORY_URI = `${BASE_URI}inventory`;
export const LOCATION_URI = `${BASE_URI}location`;
export const RESERVATION_URI = `${BASE_URI}reservation`;
export const ONLINEMOVEIN_URI = `${BASE_URI}onlinemovein`;
export const REVIEW_URI = `${BASE_URI}reviews`;
export const Email_URI = `${BASE_URI}email`;